module.exports = __webpack_public_path__ + "static/testimonial_bg-3e65fbfbee4c78d90845f30f4f306228.png";